import React from 'react';
import { connect } from 'react-redux';
import Formsy from 'formsy-react';
import { Typography, Grid, Button, Stepper, Step, StepLabel, StepContent, FormHelperText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TextInput from 'components/inputs/TextInput';
import { formatDate } from 'utils/dates';
import humanizeString from 'humanize-string';
import LoadingSpinner from '../LoadingSpinner';
import { submissionModelName } from 'utils/contentHelper';
import { fetchSubmission } from 'actions/SubmissionActions';
import ReCAPTCHA from 'react-google-recaptcha';
import { Helmet } from 'react-helmet';

export class TrackSubmissionPage extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.formRef = React.createRef();
    this.recaptchaRef = React.createRef();
    this.onCaptchaChange = this.onCaptchaChange.bind(this);

    this.state = {
      captchaResponse: null,
      captchaError: null
    }
  }

  componentDidUpdate() {
    const { fetchError } = this.props;

    if (fetchError) {
      this.formRef.current.updateInputsWithError({tracking_id: fetchError});
    }
  }

  handleSubmit(data, _resetForm, _invalidateForm) {
    if (this.state.captchaResponse) {
      this.setState({captchaError: null});
      this.props.fetchSubmission(this.props.promotion_id, data.tracking_id, this.state.captchaResponse);
      // Reset recaptcha
      if (this.recaptchaRef.current) {
        this.recaptchaRef.current.reset();
        this.onCaptchaChange(null);
      }
    } else {
      this.setState({captchaError: 'Captcha is required'});
    }
  }

  onCaptchaChange(captchaResponse) {
    this.setState({captchaResponse});
  }

  render() {
    const { promotion, submission, isFetching } = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>{promotion.name} | Track {submissionModelName(promotion, true)}</title>
        </Helmet>
        <Typography variant="h4" gutterBottom align="center">
          Track {submissionModelName(promotion, true)}
        </Typography>

        <Formsy noValidate onValidSubmit={this.handleSubmit} ref={this.formRef}>
          <LoadingSpinner show={isFetching} />
          <Grid container spacing={1} justifyContent="center">
            <Typography variant="body2" paragraph align="center">
              Enter your {submissionModelName(promotion, true)} ID below to see the status of your {submissionModelName(promotion)}.
            </Typography>
            <Grid size={{sm: 8, xs: 11}}>
              <TextInput name="tracking_id" label={submissionModelName(promotion, true) + ' ID'} required
                validations={{isLength: 8}}
                validationErrors={{isLength: 'must be 8 digits', isDefaultRequiredValue: "can't be blank"}}
              />

              <ReCAPTCHA
                sitekey={window.CAPTCHA_CLIENT_KEY || ''}
                onChange={this.onCaptchaChange}
                className="g-recaptcha"
                ref={this.recaptchaRef}
              />
              {this.state.captchaError &&
                <FormHelperText error>{this.state.captchaError}</FormHelperText>
              }

            </Grid>
          </Grid>
          <div className="button-container">
            <Button type="submit" variant="contained" color="primary">Submit</Button>
          </div>
        </Formsy>

        {submission && submission.history &&
          <React.Fragment>
            <Typography variant="h4" paragraph align="center" style={{marginTop: '1em'}} role="alert" aria-atomic="true">
              {submissionModelName(promotion, true)} ID: {submission.tracking_id}
            </Typography>
            <Grid container spacing={2} justifyContent="center">
              <Stepper activeStep={submission.history.length} orientation="vertical">
                <Step>
                  <StepLabel>
                    <Typography variant="h5" role="alert" aria-atomic="true">
                      {formatDate(submission.created_at)} - {submissionModelName(promotion, true)} submitted
                    </Typography>
                  </StepLabel>
                </Step>
                {submission.history.map((statusChange, index) => (
                  <Step key={index + 1}>
                    <StepLabel slots={{stepIcon: CheckCircleIcon}} slotProps={{stepIcon: {color: 'primary', active: null, error: null, completed: null}}} error={statusChange.status === 'declined' || statusChange.status === 'fulfilment_failed'}>
                      <Typography variant="h5">
                        {formatDate(statusChange.date)} - {humanizeString(statusChange.status)}
                      </Typography>
                    </StepLabel>
                    {(statusChange.status === 'declined' || statusChange.status === 'fulfilment_failed') &&
                      <StepContent>
                        <Typography variant="h5">Reason: {statusChange.description}</Typography>
                      </StepContent>
                    }
                    {statusChange.status === 'fulfilled' && submission.tracking_url != null && submission.tracking_number != null &&
                      <StepContent>
                        <Typography variant="h5">
                          Tracking URL: <a href={submission.tracking_url} target="_blank">{submission.tracking_url}</a>
                        </Typography>
                        <Typography variant="h5">Tracking Number: {submission.tracking_number}</Typography>
                      </StepContent>
                    }
                  </Step>
                ))}
              </Stepper>
            </Grid>
          </React.Fragment>
        }
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    promotion: state.promotion.promotion,
    ...state.submission
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchSubmission: (promotionId, trackingId, captchaResponse) => {
      dispatch(fetchSubmission(promotionId, trackingId, captchaResponse));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackSubmissionPage);
